// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-card-para',
//   imports: [],
//   templateUrl: './card-para.component.html',
//   styleUrl: './card-para.component.scss'
// })
// export class CardParaComponent {

// }

import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
// import { CallCenter } from '../../../Interfaces/callcenter.interface';
// import CallCenterData from '../../../../assets/SampleData/callCenter.json'
// import data from'../../../../assets/SampleData/help.json'
// import { Content_1 } from '../../../Interfaces/content.interface';

@Component({
  selector: 'app-card-para',
  imports: [CommonModule,MatGridListModule,MatCardModule],
  templateUrl: './card-para.component.html',
  styleUrl: './card-para.component.scss'
})


export class CardParaComponent  implements OnChanges{

  @Input() items :any =[] ;

  constructor(){

  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("the changes", changes);
    console.log("the input", this.items);
  }
  // locations: CallCenter[] = CallCenterData['call-center'];
  // content: Content_1 =data['call-center']

}

